import Store from "App/Store.js";

export default checkoutBasketUpsells => Store.dispatch({type: "checkoutBasketUpsells", checkoutBasketUpsells});
